import { Block, CheckCircle } from "@mui/icons-material";

export const insurancePolicyListColumns = [
    {
        Header: 'Provider',
        accessor: 'providerName',
        enableFilter: true
    },
    {
        Header: 'Policy #',
        accessor: 'policyNumber',
        enableFilter: true
    },
   
];